export class ResetPasswordModel {
  password_reset_token!: string;
  password!: string;
  confirm_password!: any;
  client_id!: any;
}
